/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Term } from './Term';

export type SLA = {
    readonly url?: string;
    sla_type?: SLA.sla_type;
    name: string;
    is_default?: boolean;
    readonly terms?: Array<Term>;
};

export namespace SLA {

    export enum sla_type {
        TICKET_SLA = 'TICKET_SLA',
        DELIVERY_SLA = 'DELIVERY_SLA',
        PHONE_LOAN_AGREEMENT = 'PHONE_LOAN_AGREEMENT',
        VOUCHER_SLA = 'VOUCHER_SLA',
    }


}
